import { Box, Button, Typography } from "@mui/material"
import { useAppSelector } from "../../Redux/store"
import { TalentProfileCreationSteps } from "../../Types/General"
import { GetEnumLength } from "../../Utils/Object"

interface IProps {
    handleNext: () => void,
    handleBack: () => void
}

export const TalentProfileCreationModalFooter = ({ handleNext, handleBack }:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const step = useAppSelector( state => state.TalentProfileCreation.step);
    const nextDisabled = useAppSelector( state => state.TalentProfileCreation.nextDisabled);
    const skippableSteps = [
        TalentProfileCreationSteps.Parsing, 
        TalentProfileCreationSteps.Education, 
        TalentProfileCreationSteps.Certifications, 
        TalentProfileCreationSteps.Portfolio
    ]
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Box flex={1} display={'flex'} alignItems={'center'}>
                {/** Don't forget to remove the substraction step when parsing is re-enabled*/}
                <Typography variant={'body-small'} color={'black.300'}>Step {step} of {GetEnumLength(TalentProfileCreationSteps)-1}</Typography>
            </Box>
            <Box flex={1} display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gap={1}>
                {skippableSteps.some( skippableStep => skippableStep === step) && <Button variant={'text'} onClick={handleNext}>Skip</Button>}
                { step > 1 && <Button variant={'outlined'} onClick={handleBack}>Back</Button>}
                <Button 
                    variant={'contained'} 
                    onClick={handleNext} 
                    disabled={nextDisabled}
                    sx={{
                        "&.Mui-disabled": {
                            background: 'black.50',
                            border: 'none',
                            color: 'primary.main'
                        }
                    }}
                >
                    {step == TalentProfileCreationSteps.Photo  ? 'Create profile' : 'Next'}
                </Button>
            </Box> 
        </>
    )
}